import { BarComposition } from './types'

type CalcSliderSlopeInterceptTypes = {
  barWidth: number
  barsCompositions: BarComposition[]
  graphWidth: number
}

export type SliderSlopeInterceptType = {
  slope: number
  yIntercept: number
}

export const calcSliderSlopeIntercept = ({
  barWidth,
  barsCompositions,
  graphWidth,
}: CalcSliderSlopeInterceptTypes): Array<SliderSlopeInterceptType> => {
  const distanceBetweenBars =
    // calc distance between mid point of first & last bar
    (graphWidth - barWidth) / (barsCompositions.length - 1)
  const sliderSlopeInterceptList: SliderSlopeInterceptType[] = []

  for (let i = 0; i < barsCompositions.length - 1; i++) {
    const slope =
      (barsCompositions[i + 1].barHeight - barsCompositions[i].barHeight) /
      distanceBetweenBars
    const yIntercept =
      barsCompositions[i].barHeight - slope * i * distanceBetweenBars

    sliderSlopeInterceptList.push({
      slope,
      yIntercept,
    })
  }

  // Copy the last index to length match other list for the graphic positions
  sliderSlopeInterceptList.push(
    sliderSlopeInterceptList[sliderSlopeInterceptList.length - 1],
  )

  return sliderSlopeInterceptList
}
